import AssignmentApi from './AssignmentApi';
export default AssignmentApi;
